import { createFileRoute, notFound } from "@tanstack/react-router";
import { VolumeDetail, VOLUME_TABS, type VolumeTab } from "../../features/storage/volume-detail";

export const Route = createFileRoute("/_authed/$org/$project/volumes/$name/$tab")({
  beforeLoad: ({ params }) => {
    if (!VOLUME_TABS.includes(params.tab as VolumeTab)) throw notFound();
  },
  component: VolumePage,
});

function VolumePage() {
  const { org, project, name, tab } = Route.useParams();
  return <VolumeDetail scope={{ org, project }} name={name} tab={tab as VolumeTab} />;
}
